import { useRef, useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ScrollHeading = ({ children, className = '', dataTestId }) => {
  const ref = useRef(null);
  const [isReady, setIsReady] = useState(false);
  
  // Delay scroll tracking until component is mounted and positioned
  useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), 100);
    return () => clearTimeout(timer);
  }, []);
  
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'start start']
  });
  
  const scrollOpacity = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    [1, 0.85, 0.85]
  );

  return (
    <motion.h1
      ref={ref}
      style={{ opacity: isReady ? scrollOpacity : 1 }}
      className={`${className} uppercase overflow-visible`}
      data-testid={dataTestId}
    >
      {children}
    </motion.h1>
  );
};

export default ScrollHeading;
